module.exports = __webpack_public_path__ + "img/buffet.013c9b55.png";